import { type StoryblokMultilinkType } from './model/storyblokTypes.generated'

export const getStoryblokHrefLink = (
  link?: StoryblokMultilinkType,
): string | undefined => {
  if (!link) {
    return ''
  }

  if (link.linktype === 'story') {
    return `/${link.cached_url}`
  }
  if (link.linktype === 'url') {
    return link.cached_url
  }

  return ''
}
